import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiBaseUrl } from "../../config"; // Import the dynamic API base URL

const loginUser = createAsyncThunk("user/login", async (loginData) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      // Add other headers as needed
    },
  };

  const response = await axios.post(
    `https://${apiBaseUrl}/login`,
    { username: loginData.email, password: loginData.password },
    config
  );

  return response.data;
});

export { loginUser };
